import { observer } from 'mobx-react-lite';
import { DATA } from '../../game/data';
import { IMAGES } from '../../game/data/images';
import React from 'react';
import { playNextAudio } from '../../game/audio';

export const AudioButtons: React.FC = observer(() => {
  const [hovered, setHovered] = React.useState(false);
  return (
    <div
      style={{ position: 'absolute', top: 8, left: 8, display: 'flex', flexDirection: 'column' }}
      onMouseEnter={() => {
        setHovered(true);
      }}
      onMouseLeave={() => {
        setHovered(false);
      }}
    >
      <div style={{ display: 'flex' }}>
        <div
          style={{ opacity: 0.5, cursor: 'pointer' }}
          onClick={() => {
            DATA.setIsMute(!DATA.isMuted);
          }}
        >
          <img src={DATA.isMuted ? IMAGES.ICONS.audio_off : IMAGES.ICONS.audio_on} style={{ width: '2rem' }} />
        </div>
        <div style={{ opacity: 0.5, cursor: 'pointer' }} onClick={() => playNextAudio()}>
          <img src={IMAGES.ICONS.next} style={{ width: '2rem' }} />
        </div>
      </div>
      {hovered && <div style={{ opacity: 0.4, fontSize: '0.8rem' }}>Music by Artur Aravidi from PixaBay</div>}
    </div>
  );
});
